'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = ['M16 112l0 384 480 0 0-384L16 112zm48 48l16 0 288 0 16 0 0 16 0 256 0 16-16 0L80 448l-16 0 0-16 0-256 0-16zm392 48a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M141 1.8l115 92 115-92 10 12.5L278.8 96 496 96l16 0 0 16 0 384 0 16-16 0L16 512 0 512l0-16L0 112 0 96l16 0 217.2 0L131 14.2 141 1.8zM496 496l0-384L16 112l0 384 480 0zM368 176L80 176l0 256 288 0 0-256zM80 160l288 0 16 0 0 16 0 256 0 16-16 0L80 448l-16 0 0-16 0-256 0-16 16 0zm360 48a8 8 0 1 0 -16 0 8 8 0 1 0 16 0zm-32 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a8 8 0 1 0 0-16 8 8 0 1 0 0 16zm0-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;